import ModelUpdate from "@/models/ModelUpdate";
import {IGlobalConfigAdmin} from "@/models/global-config/GlobalConfigAdminModels";
import {ValidationRule} from "@/declarations/ValidationRule";

export default class GlobalConfigUpdateBulkOfferThreshold extends ModelUpdate<IGlobalConfigAdmin> {

	public bulkOfferThresholdMeters!: number | null;

	public constructor(model: IGlobalConfigAdmin) {
		super();
		this.setDetailModel(model);
	}

	protected initializeWithDetailModelData(detailModel: IGlobalConfigAdmin): void {
		this.bulkOfferThresholdMeters = detailModel.bulkOfferThresholdMeters ?? null;
	}

	public rules(): ValidationRule[] {
		return [];
	}

}
